var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.36337 8.36358C4.71484 8.01211 5.28469 8.01211 5.63616 8.36358L11.9998 14.7272L18.3634 8.36358C18.7148 8.01211 19.2847 8.01211 19.6362 8.36358C19.9876 8.71505 19.9876 9.2849 19.6362 9.63637L12.6362 16.6364C12.2847 16.9878 11.7148 16.9878 11.3634 16.6364L4.36337 9.63637C4.01189 9.2849 4.01189 8.71505 4.36337 8.36358Z",
    fill: "#171719"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.1f657fab6501c8e0fbf65c1b5b235e96.svg";
export { ForwardRef as ReactComponent };